<app-confirm-dialog
  [visible]="confirmationDialogVisible"
  variant="secondary"
  heading="Confirmation"
  [message]="confirmationDialogMessage"
  cancelText="No"
  (confirmed)="confirmConfirmationDialog()"
  (cancelled)="cancelConfirmationDialog()">
</app-confirm-dialog>
<div class="p-g-12 p-dataView-tecfolk-fix pettyCashPage">
   <div class="p-g">
      <div class="p-g-12">
         <div class="card card-w-title">
            <h1>{{setLabel("pettyCashLabel")}}</h1>
            <div class="pettyCashStat">
              <div class="addExpenseMain">
               <div class="pettyCashCurrentBalance">
                  <label class="BalanceLabel">{{setLabel("currentBalance:Label")}}</label>
                  <label>{{user.pettyCash | number: '1.0-0'}}</label>
               </div>
               <div>
               </div>
               <div class="pettyCashActionBtn">
                  <app-action-button
                     variant="dark"
                     size="sm"
                     [text]="setLabel('addExpenseLabel')"
                     icon="pi pi-plus"
                     [title]="setLabel('addExpenseLabel')"
                     [ariaLabel]="setLabel('addExpenseLabel')"
                     [disabled]="loading"
                     (action)="showAddExpensePopup()">
                  </app-action-button>
               </div>
              </div>
            <div class="addExpenseFilterMain">
               <div class="filterFields">
                  <span class="fieldTitle">{{setLabel("fromLabel")}}</span>
                  <p-calendar class="p-calendar-from" [yearNavigator]="true" yearRange="1950:2040"
                     [monthNavigator]="true" [(ngModel)]="from" [placeholder]='setLabel("fromDatePlaceholderLabel")'
                     [inputStyle]="{'color':'#000000'}" name="joinDate" [inline]="false" dateFormat="dd/mm/yy"
                     [showIcon]="true" (onSelect)="getUserPettyExpenses()">
                  </p-calendar>
               </div>
               <div class="filterFields">
                  <span class="fieldTitle">{{setLabel("toLabel")}}</span>
                  <p-calendar class="p-calendar-to" [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                     [(ngModel)]="to" [placeholder]='setLabel("toDatePlaceholderLabel")'
                     [inputStyle]="{'color':'#000000'}" name="joinDate" [inline]="false" dateFormat="dd/mm/yy"
                     [showIcon]="true" (onSelect)="getUserPettyExpenses()">
                  </p-calendar>
               </div>
               <div *ngIf="user.role === 'Admin' || user.role === 'Super Admin'" class="filterFields">
                  <span class="fieldTitle" for="">{{setLabel("selectUserLabel")}}</span>
                  <p-dropdown
                  class="p-inputtext"
                  [options]="accountHolderOptions"
                  name="selectPackage"
                  [style]="{'width':'100%','background':'none'}"
                  required
                  [(ngModel)]="optionValue"
                  (onChange)="onChangeHolderValue()" >
                  </p-dropdown>
              </div>
            </div>
            <div class="exportPettyExpenseButton" *ngIf="pettyExpenses && pettyExpenses.length > 0">
               <app-action-button
                  variant="dark"
                  size="sm"
                  [text]="setLabel('exportTooltipLabel')"
                  icon="fa fa-download"
                  [title]="setLabel('exportTooltipLabel')"
                  [ariaLabel]="setLabel('exportTooltipLabel')"
                  (action)="ExportData(pettyExpenses, 'PettyExpense_Report')">
               </app-action-button>
            </div>
            </div>
            <div class="pettyCashTable">
               <p-table [value]="pettyExpenses" [loading]="loading"
                  class="feeTable hideTabileHeadOnMobile p-table-tecfolk-fix">
                  <ng-template pTemplate="header">
                     <tr>
                        <th>{{setLabel("amountLabel")}}</th>
                        <th>{{setLabel("expenseTypeLabel")}}</th>
                        <th>{{setLabel("dateLabel")}}</th>
                        <th>{{setLabel("detailsLabel")}}</th>
                        <th>{{setLabel("viewImageLabel")}}</th>
                        <th>{{setLabel("createdOnLabel")}}</th>
                        <th>{{setLabel("commentLabel")}}</th>
                        <th>{{setLabel("actionLabel")}}</th>
                     </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-pe>
                     <tr>
                        <td>
                           <span class="hideonMobile">{{setLabel("amountLabel")}}</span>
                           {{pe.amount | number: '1.0-0'}}</td>
                        <td>
                           <span class="hideonMobile">{{setLabel("expenseTypeLabel")}}</span>
                           {{pe.type}}</td>
                        <td>
                           <span class="hideonMobile">{{setLabel("dateLabel")}}</span>
                           {{pe.date | date:'dd/MM/yyyy'}}</td>
                        <td class="pettyCashDetailsCell">
                           <span class="hideonMobile">{{setLabel("detailsLabel")}}</span>
                           <span class="pettyCashDetailsText" [title]="getDetailOfExpance(pe)">{{getDetailOfExpance(pe)}}</span></td>
                     <td>
                        <span class="hideonMobile">{{setLabel("viewImageLabel")}}</span>
                        <a *ngIf="pe.pettyImageUrl"
                           (click)="openPhoto(pe.pettyImageUrl)">
                           <i class="fa fa-paperclip fa-lg moveIcon" [pTooltip]='setLabel("onlinePaymentTooltipLabel")' tooltipPosition="top" style="cursor:pointer;"></i>
                        </a>
                     </td>
                     <td>
                        <span class="hideonMobile">{{setLabel("createdOnLabel")}}</span>
                        {{pe.createdDate | date:'dd/MM/yyyy'}}
                     </td>
                     <td>
                        <span class="hideonMobile">{{setLabel("commentLabel")}}</span>
                        <span *ngIf="pe.description" class="message-icon" (click)="openMessageDialog(pe.description)">
                           <i class="fa fa-comment-o moveCommentIcon" style="cursor: pointer;" title="View Message"></i>
                        </span>

                     </td>
                     <td>
                        <span class="pettyCashAmountRefundBtn">
                           <button *ngIf="pe.type === 'Lending' && !pe.isReturned" pButton class="p-button-success" icon="pi pi-refresh" pTooltip="Refund Amount"
                               tooltipPosition="top" (click)="refundPettyAmount(pe._id)"></button>
                        </span>
                        <span class="deletePettyCashBtn">
                           <span class="hideonMobile">{{setLabel("actionLabel")}}</span>
                           <button *ngIf="(this.role.name === 'Admin' || this.role.name === 'Super Admin') && !(pe.type === 'Lending' && !pe.isReturned)"
                              pButton type="button" pTooltip='Delete Entry' tooltipPosition="top" class="p-button-success p-button"
                              icon="fa fa-times" style="background: #F44336;" (click)="deleteThisPettyExpense(pe)"></button>
                        </span>
                     </td>

                     </tr>
                  </ng-template>
               </p-table>
            </div>
         </div>
      </div>
   </div>
<div *ngIf="imgPreview" (click)="closePhotoPreview()"
    style="position: fixed; top: 0; left: 0; height: 100vh; width: 100vw; z-index: 999999; display: flex; align-items: center; justify-content: center; background: #000000cf;">
    <svg (click)="closePhotoPreview()"
        style="width: 20px; position: absolute; top: 30px; right: 40px; color: #fff; cursor: pointer;"
        aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11"
        role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
        <path fill="currentColor"
            d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
        </path>
    </svg>
    <img [src]="imgPreviewImg" onerror="this.src = 'assets/layout/images/avatarBoyImage.png'"
        style="max-width: 90%; max-height: 90%; width: auto; height: auto; object-fit: contain;">
</div>
</div>
<!-- <div *ngIf="pettyExpenseDialogVisibility" class="tecfolkProfileDialogFix">
   <p-dialog [header]='setLabel("addPettyExpenseHeaderLabel")' [(visible)]="pettyExpenseDialogVisibility">
      <div class="pettyExpensePopup">
         <div class="pettyExpenseTpe">
            <label>{{setLabel("paymentModeLabel")}}</label>
            <p-dropdown [options]="paymentOptions" (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
         </div>
         <div class="pettyExpenseAmount">
            <label>{{setLabel("amountLabel")}}</label>
            <input type="number" min="0" pInputText name="pettyExpenseAmount" [(ngModel)]="amount" />
         </div>

         <div class="pettyExpenseTpe">
            <label>{{setLabel("expenseTypeLabel")}}</label>
            <select style="width: 14em; height: 2em;" pInputText type="text" [(ngModel)]="expenseType">
               <option value="Purchasing">{{setLabel("purchasingLabel")}}</option>
               <option value="Lending">{{setLabel("lendingLabel")}}</option>
               <option value="Bills">{{setLabel("billsLabel")}}</option>
               <option value="Account Deducted">{{setLabel("accountDeductedLabel")}}</option>
            </select>
         </div>
         <div *ngIf="expenseType === 'Lending'" class="pettyExpenseTpe">
            <Label>{{setLabel("borrowerNameLabel")}}</Label>
            <p-dropdown name="Borrower Name" style="width: 14em; height: 2em;" [options]="userOptions"
               [(ngModel)]="selectedUser"  (onChange)="dropdownChange($event)">
            </p-dropdown>
         </div>
         <div *ngIf="expenseType === 'Account Deducted'" class="pettyExpenseTpe">
            <Label>{{setLabel("accountHolderNameLabel")}}</Label>
            <p-dropdown name="Account Holder Name" style="width: 14em; height: 2em;" [options]="usersOptions"
               [(ngModel)]="selectedUser"  (onChange)="dropdownChange($event)">
            </p-dropdown>
         </div>
         <div *ngIf="expenseType === 'Purchasing'" class="pettyExpenseTpe">
            <Label>{{setLabel("productNameLabel")}}</Label>
            <select style="width: 14em; height: 2em;" type="text" pInputText name="Purchased Item"
               [(ngModel)]="purchasedItem">
               <optgroup label="Foods">
                  <option value="Pizza">{{setLabel("pizzaLabel")}}</option>
                  <option value="Burger">{{setLabel("burgerLabel")}}</option>
                  <option value="Pasta">{{setLabel("pastaLabel")}}</option>
                  <option value="Biryani">{{setLabel("biryaniLabel")}}</option>
                  <option value="Pulao">{{setLabel("pulaoLabel")}}</option>
                  <option value="Desi Food">{{setLabel("desiFoodLabel")}}</option>
               </optgroup>
               <optgroup label="Tea">
                  <option value="Coffee">{{setLabel("coffeeLabel")}}</option>
                  <option value="Green Tea">{{setLabel("greenTeaLabel")}}</option>
                  <option value="Tea">{{setLabel("teaLabel")}}</option>
               </optgroup>
               <optgroup label="Drinks">
                  <option value="Minarl Water">{{setLabel("mineralWaterLabel")}}</option>
                  <option value="Juice">{{setLabel("juiceLabel")}}</option>
                  <option value="Cold Drinks">{{setLabel("coldDrinksLabel")}}</option>
                  <option value="Energy Drinks">{{setLabel("energyDrinksLabel")}}</option>
               </optgroup>
               <optgroup label="Others">
                  <option value="Air freshner">{{setLabel("airFreshnerLabel")}}</option>
                  <option value="Print Paper">{{setLabel("printPaperLabel")}}</option>
                  <option value="Equipment Part">{{setLabel("equipmentPartLabel")}}</option>
               </optgroup>
            </select>
         </div>
         <div *ngIf="expenseType === 'Bills'" class="pettyExpenseTpe">

            <Label>{{setLabel("billTypeLabel")}}</Label>
            <select style="width: 14em; height: 2em;" type="text" pInputText name="Bill Type" [(ngModel)]="billType">
               <option value="Electricity">{{setLabel("electricityLabel")}}</option>
               <option value="Internet">{{setLabel("internetLabel")}}</option>
               <option value="Maintenance">{{setLabel("maintenanceLabel")}}</option>
               <option value="Repairing">{{setLabel("repairingLabel")}}</option>
               <option value="Water Bottles">{{setLabel("waterBottlesLabel")}}</option>
               <option value="Other">{{setLabel("otherLabel")}}</option>
            </select>
         </div>

         <div class="pettyExpenseTpe">
            <div style="justify-content: space-between;" class="p-inputgroup">
               <span>{{setLabel("commentLabel")}}</span>
               <textarea style="width: 59% !important; border: 1px solid darkgray;" rows="5" cols="50"
                  [(ngModel)]="description" name="description" pInputTextarea></textarea>
            </div>
         </div>
         <div class="pettyExpenseBtn">
            <button class="p-button-success" pButton
               (click)="addPettyExpense()">{{setLabel("addExpenseLabel")}}</button>
         </div>
      </div>
   </p-dialog>
</div> -->
<p-dialog header="Message" [(visible)]="displayMessageDialog" [modal]="true" [dismissableMask]="true"
  [baseZIndex]="10000" [style]="{ width: '500px' }" styleClass="my-unique-dialog">
  {{ selectedMessage }}
</p-dialog>
<div *ngIf="pettyExpenseDialogVisibility" class="tecGym-component">
   <app-pettycashdialouge (closePettyCashDialog)="closePettyCashDialog()" (isDataAddedChange)="onDataAdded($event)"
      [pettydialogVisibility]="pettyExpenseDialogVisibility"></app-pettycashdialouge>
</div>